module.exports = __webpack_public_path__ + "img/weighted_carry_2.69d87192.png";